import {
  Alert,
  AlertColor,
  Box,
  CircularProgress,
  Grid,
  Typography,
} from '@mui/material';
import { ReactNode } from 'react';

export const getProgressBar = () => {
  return (
    <Box
      sx={{
        height: '30vw',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export const getMasterProgressBar = (msg?: string) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 10000,
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `rgba(255,255,255,.8)`,
      }}
    >
      <CircularProgress />
      {msg && (
        <Typography variant="h6" ml={2}>
          {msg}
        </Typography>
      )}
    </Box>
  );
};

export const getFieldValue = (
  title: string,
  value: string | null,
  renderDataElement?: ReactNode,
  isFullWidth?: boolean,
  titleStyles: any = {},
  containerStyles = {}
) => {
  const defaultValue = '----';
  const titleStylesRender = {
    marginBottom: 0,
    fontWeight: 600,
    opacity: 0.7,
    ...titleStyles,
  };
  const containerStylesRender = {
    marginBottom: 0,
    marginTop: 0,
    ...containerStyles,
  };
  return (
    <Grid
      item
      m={2}
      xs={isFullWidth ? 12 : 5}
      sm={isFullWidth ? 12 : 4}
      md={isFullWidth ? 12 : 5}
      lg={isFullWidth ? 12 : 3}
      sx={containerStylesRender}
    >
      <Typography
        id="modal-modal-title"
        m={2}
        sx={titleStylesRender}
        variant="caption"
      >
        {title.toUpperCase() ?? defaultValue}
      </Typography>
      {value != null && (
        <Typography
          id="modal-modal-title"
          m={2}
          variant="subtitle2"
          sx={{ marginTop: 0, fontWeight: 400 }}
        >
          {value ?? defaultValue}
        </Typography>
      )}
      {value === null && renderDataElement}
    </Grid>
  );
};

export const renderAsAGridElement = (element: ReactNode) => {
  return (
    <Grid
      item
      m={2}
      xs={10}
      sm={8}
      md={8}
      lg={7}
      sx={{ marginTop: 0, marginBottom: 0 }}
    >
      {element}
    </Grid>
  );
};

export const renderAsAGridElementMini = (element: ReactNode) => {
  return (
    <Grid
      item
      m={2}
      xs={6}
      sm={3}
      md={3}
      lg={3}
      sx={{ marginTop: 0, marginBottom: 0 }}
    >
      {element}
    </Grid>
  );
};

export const getAlertBox = (
  title: string = 'Error',
  msg: string = 'Error',
  type: AlertColor | undefined = 'error'
) => {
  return (
    <Grid item xs={12} m={2} justifyContent="left">
      <Alert severity={type}>
        <Typography
          variant="body1"
          sx={{ textAlign: 'left', fontWeight: '600' }}
        >
          {title}
        </Typography>
        <Typography>{msg}</Typography>
      </Alert>
    </Grid>
  );
};
